<template>
	<div v-parallax-fit="parallax" class="hand">
		<img src="/themes/rise-theme/dist/images/estate/character-view/holly/17_RentLetterHand.png" alt="">
	</div>
</template>

<script>
	export default {
		data() {
			return {
				parallax: [
					{
						start: 7900,
						end: 10500,
						fromStyle: { transform: 'translateY(-250%) rotateZ(10deg)' },
           				toStyle: { transform: 'translateY(55%) rotateZ(10deg)' },
						easing: 'linear'
					},
					{
						start: 10500,
						end: 11500,
						fromStyle: { transform: 'translateY(55%) rotateZ(10deg)' },
           				toStyle: { transform: 'translateY(-250%) rotateZ(10deg)' },
						easing: 'linear'
					}
				]
			}
		}
	}
</script>

<style lang="scss" scoped>
	.hand {
		position: absolute;
		bottom: 132%;
		right: 30%;
		z-index: 2;
		max-width: 150px;
		transition: all 0.1s linear;
	}

	@media screen and (max-width: 1600px) {
        .hand {
            max-width: 120px;
        }
    }

    @media screen and (max-width: 1024px) {
        .hand {
            max-width: 110px;
            bottom: 127%;
            right: 29%;
        }
    }

    @media screen and (max-width: 650px) {
        .hand {
            max-width: 70px;
            bottom: 152%;
        }
    }
</style>
